import { render, staticRenderFns } from "./commissionInfo.vue?vue&type=template&id=6022dfd9&scoped=true&"
import script from "./commissionInfo.vue?vue&type=script&lang=js&"
export * from "./commissionInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6022dfd9",
  null
  
)

export default component.exports